const { DateTime } = require("luxon");

const getSlotsBySchedule = require("./getSlotsBySchedule");
const getCapacitySlots = require("./getCapacitySlots");

function filterPast(date, slots) {
  const endOfPreviousDay = DateTime.fromJSDate(date)
    .plus({ days: -1 })
    .endOf("day");

  return slots.filter((item) => {
    const slotTime = item.start;
    return slotTime > endOfPreviousDay;
  });
}

module.exports = async (firebase, business, date) => {
  let slotsArr = getSlotsBySchedule(business, date);
  console.log(
    "slotsArr: " +
      slotsArr
        .map((slot) => slot.start.toLocaleString(DateTime.DATETIME_FULL))
        .join("\n")
  );
  slotsArr = filterPast(date, slotsArr);
  const { slots } = await getCapacitySlots(firebase, business, date, slotsArr);
  return slots;
};
